import React, { useState } from "react";
import { Input, InputLabel } from "@material-ui/core/";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useStyles } from "./style";


export default function FormControlInput(props) {
  const classes = useStyles();
  const [self, setSelf] = useState(props.this);
  // const mayus =(event) => {
  //   if(event.target.value !== undefined || event.target.value !== ''  || event.target.value !== ' ' || event.target.value !== null) {
  //     event.target.value = event.target.value.toUpperCase();    
  //     console.log('save: ', event.target)
  //   }
  // }  
  return (
    <>
      {props.showInputControl && (
        <FormControl className={classes.formControl} style={props.minWidth ? { minWidth: props.minWidth } : {minWidth: 300}}>
          <InputLabel htmlFor="component-error" className={classes.InputLabel} >
            {props.label}
          </InputLabel>
          <Input 
            // onKeyUp={props.writeUppercase && mayus}
            type={props.type || 'text'}
            error={props.isError}
            key={props.name}
            id={props.name}
            name={props.name}
            autoComplete={props.autoComplete ? "" : "none"}
            value={props.value || ""}
            autoFocus={true}            

            // onChange={props.handleChange}
            onChange={(event) => {
              props.handleChange(event, self);
            }}
            onKeyPress={
              props.keyPress
            }
            disabled={props.disabled}
            aria-describedby="component-error-text"
          />
          {
            props.isError ? ( <FormHelperText className={classes.textError} id="component-error-text">{props.errorMessages}</FormHelperText>) 
            : null
            // <FormHelperText className={classes.textSuccess} id="component-success-text">{props.errorMessages}</FormHelperText>
          }
        </FormControl>
      )}
    </>
  );
}

FormControlInput.defaultProps = {
  showInputControl: true,
};
